import React from "react"
import { AppStatusFilterToggle } from "@components"
import { reportListStatusFilter } from "Pages/ReportsAlerts/Reports/@signals"

// Same Off/On filter of the table, shown as a selector next to the title instead of a filter chip
export default function ReportTableStatusToggle() {
	return <AppStatusFilterToggle
		aria-label="Reports shown"
		data-tour-id="tour-status-toggle"
		filter={reportListStatusFilter.value || []}
		onChange={filter => reportListStatusFilter.value = filter}
	/>
}
